export default __webpack_public_path__ + "static/media/discover-events.a99e33a3.svg";